import styled from "styled-components";

const Container = styled.div`
  color: white;
  margin-bottom: 1rem;
`;

export { Container };
